var sectionTitleProps = {
  title: 'PAID TO',
  showSpacer: true,
  spacerProps: {
    left: {
      desktop: 'SPACING_16',
      mobile: 'SPACING_16'
    },
    right: {
      desktop: 'SPACING_16',
      mobile: 'SPACING_16'
    },
    top: {
      desktop: 'SPACING_16',
      mobile: 'SPACING_16'
    }
  }
};
var orderSummaryCarProps = {
  showShadow: false,
  showDividerSection: true,
  subTitle: 'UPI ID: merchant@okhdf',
  priceDetails: {
    price: '₹599.00'
  },
  removeCardBorderRadius: true,
  testID: 'OrderSummaryCardWidgetContainer',
  title: 'Merchant name',
  iconProps: {
    size: 'sm',
    variant: 'initials',
    style: {
      borderColor: '#D2D5F6',
      backgroundColor: '#ECEDFF',
      borderWidth: 1
    }
  },
  showAvatar: true
};
var linkListProps = {
  avatarIcon: 'TickIcon',
  heading: 'Transaction Complete',
  subHeading: '12 Feb 2022, 12:32 pm',
  noPressEffect: true,
  avatarProps: {
    size: 'sm',
    style: {
      backgroundColor: '#18bda9'
    }
  },
  showSpacer: true,
  spacerProps: {
    top: {
      mobile: 'SPACING_6'
    },
    bottom: {
      mobile: 'SPACING_6'
    }
  }
};
var trackOrderStepperWidget = {
  size: 'sm',
  showStepperTitle: true,
  withAccordion: true,
  withAccordionProps: {
    isExpanded: false,
    useLinkList: true,
    allowAndroidAnimation: true,
    linkListProps: {
      avatarIcon: 'CancelIcon',
      heading: 'payment failed',
      subHeading: '03 Dec 2024, 12:18 PM',
      avatarProps: {
        style: {
          backgroundColor: '#EB4F4F'
        },
        iconProps: {
          color: '#ffffff'
        },
        size: 'sm'
      }
    },
    onToggleMetaData: {
      actions: []
    }
  },
  showBottomButton: true,
  steps: [{
    heading: 'payment initiated',
    subHeading: '12:18 PM',
    iconName: 'TickIcon',
    stepsBackgroundColor: '#1ADCC5',
    stepNumber: '1'
  }, {
    heading: 'payment failed',
    subHeading: 'any money debited will be refunded within 3-5 business days.',
    stepNumber: '2',
    state: 'danger'
  }],
  stepperTitleProps: {
    title: 'STATUS',
    backgroundColor: '#F4F5FF'
  },
  direction: 'vertical',
  bottomButtonProps: {
    rightCta: {
      buttonType: 'tertiary',
      style: {
        alignItems: 'flex-start'
      },
      title: 'NEED HELP?'
    },
    onRightCtaPress: {
      actions: [{
        payload: {
          eventData: {
            action: 'show',
            widgetData: {
              headerTitle: 'Transaction successfull'
            }
          },
          eventName: 'KeyTxnDetailComplaintStatusBSSection'
        },
        type: 'nativeEventEmitter'
      }, {
        payload: {
          widgetId: 'TransactionStatusBSCardID',
          widgetData: {
            subtitle: {
              text: 'any amount deducted will be refunded to your account within 3-5 working days.'
            },
            style: {
              backgroundColor: '#ECEDFF'
            },
            statusCardImage: {
              size: 'lg',
              imageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/transaction_failed.png'
            },
            type: 'image'
          }
        },
        type: 'updateWidgetProps'
      }, {
        payload: {
          widgetId: 'TransactionStatusBSButtonsId',
          widgetData: {
            setCheckedBoxState: true,
            noPadding: true,
            backgroundColor: 'LILAC_300',
            showSpacer: true,
            isValid: true,
            isInsideGridColumn: true,
            onActionCtaPressMetaData: {
              id: 'actioncta'
            },
            buttonData: {
              onLeftCtaPress: {
                id: 'left cta press',
                actions: [{
                  payload: {
                    eventData: {
                      action: 'hide'
                    },
                    eventName: 'KeyTxnDetailComplaintStatusBSSection'
                  },
                  type: 'nativeEventEmitter'
                }, {
                  payload: {
                    eventData: {
                      action: 'show'
                    },
                    eventName: 'KeyTxnDetailCallBsSection'
                  },
                  type: 'nativeEventEmitter'
                }]
              },
              rightCta: {
                buttonType: 'primary',
                title: 'GOT IT'
              },
              leftCta: {
                buttonType: 'secondary',
                title: 'HELP'
              },
              onRightCtaPress: {
                id: 'right cta press',
                actions: [{
                  payload: {
                    eventData: {
                      action: 'hide'
                    },
                    eventName: 'KeyTxnDetailComplaintStatusBSSection'
                  },
                  type: 'nativeEventEmitter'
                }]
              },
              direction: 'row'
            },
            spacerProps: {
              top: {
                mobile: 'SPACING_20'
              },
              bottom: {
                mobile: 'SPACING_20'
              }
            }
          }
        },
        type: 'updateWidgetProps'
      }]
    }
  }
};
export var defaultProps = {
  withCard: true,
  withCardProps: {
    withRoundedBorder: true,
    showShadow: false,
    noPadding: true,
    noHorizontalPadding: true
  },
  sectionTitleWidgetProps: sectionTitleProps,
  orderSummaryCardProps: orderSummaryCarProps,
  trackOrderStepperWidget: trackOrderStepperWidget,
  showCollapsible: true,
  linkListItemProps: linkListProps
};